(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'News'];

    function NewsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, News) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publish = publish;

        // debounce:false makes the editor write to ng-model on every change instead of only
        // when it considers itself dirty. A native paste never sets that dirty flag, so pasted
        // content was silently dropped when it followed typed text.
        vm.tinyMceOptions = {
            debounce: false,
            plugins: ['paste', 'lists', 'link', 'autolink'],
            menubar: false,
            toolbar: 'undo redo | bold italic underline | bullist numlist | link unlink | removeformat',
            setup: function (editor) {
                vm.articleEditor = editor;
            }
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        // Take the editor's content directly, in case a button is clicked before it syncs
        function flushArticle () {
            if (vm.articleEditor) {
                vm.news.postingArticle = vm.articleEditor.getContent();
            }
        }

        function save () {
            flushArticle();
            vm.isSaving = true;
            if (vm.news.id !== null) {            	
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
            	vm.news.postingDate = null;
            	vm.news.publish = false;
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }
        
        function publish () {
            flushArticle();
            vm.isPublishing = true;
            if (vm.news.id !== null) {
            	vm.news.publish = true;
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
            	vm.news.publish = true;            
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }


        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:newsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
